// 说明书
<template>
  <div class="manual">
    <van-nav-bar :title="$t('menu.manual')" @click-left="$router.go(-1)" left-arrow fixed placeholder z-index="5" />
    <van-cell-group inset>
      <van-cell v-for="item in list" :key="item.id" :title="item.title" title-style="font-weight: bold;" is-link @click="linkToDetail(item)" />
    </van-cell-group>
    <div class="flex justify-center" style="margin-top: 37px;">
      <!-- <van-button plain round color="#000" @click="init">Change batch</van-button> -->
    </div>
  </div>
</template>

<script>
import { getSynopsisList } from '@/api'
export default {
  name: 'Manual',
  data () {
    return {
      list: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化列表
    async init () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true
      })
      await getSynopsisList({
        pageSize: 1000,
        pageNum: 1
      }).then(res => {
          this.loading = false
          this.list = res.data
      }).finally(() => {
        this.$toast.clear()
      })
    },
    linkToDetail (item) {
      this.$router.push({
        name: 'manualDetail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="less">
  .manual {
    .van-hairline--bottom {
      &:after {
        border-bottom-width: 0;
      }
    }
    .van-cell-group, .van-cell {
      background: transparent;
    }
    .card {
      position: relative;
      background: #fff;
      padding: 28px 33px;
      border-radius: 15px;
      margin-bottom: 15px;
      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;
        margin-right: 30px;
        border-radius: 50%;
        overflow: hidden;
        border: 2px solid #969696;
        img {
          width: 100%;
          object-fit: cover;
        }
      }
      .info {
        font-family: PingFang SC Regular, PingFang SC Regular-Regular;
        font-size: 25px;
        color: #010101;
      }
      .desc {
        display: block;
        margin-top: 20px;
        font-size: 20px;
        line-height: 1.5;
      }
      // width: 100%;
      // box-sizing: border-box;
      // background: #fff;
      // border-radius: 10px;
      // margin-bottom: 20px;
      // overflow: hidden;
      .card-item {
        height: 100%;
        .left {
          width: 8%;
          border-right: 1px solid #f5f5f5;
          .index {
            font-size: 26px;
            color: #fff;
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background: #00aaff;
          }
          .select {
            padding: 0;
            height: calc(~"100% - 50px");
          }
        }
        .right {
          width: 100%;
          .content {
            .content-title {
              padding: 0 70px;
              font-weight: bold;
              font-size: 26px;
              height: 80px;
              line-height: 80px;
              border-bottom: 1px solid #f5f5f5;
            }
            .content-item {
              padding-left: 70px;
              .content-label {
                line-height: 1.5;
                color: #d0d0d0;
                font-size: 22px;
              }
              .content-value {
                line-height: 1.5;
                font-size: 22px;
                margin-bottom: 20px;
              }
            }
          }
          .btn {
            border-top: 1px solid #f5f5f5;
            .disabled {
              opacity: .5;
            }
            .btn-item {
              border-right: 1px solid #f5f5f5;
              padding: 20px 0;
              text-align: center;
              img {
                width: 36px;
                height: 36px;
              }
              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }
    .title {
      padding: 0px 33px 20px;
      font-size: 40px;
      font-weight: bold;
    }
  }
</style>
